export class SmartCaptcha {
    constructor(options = {}) {
        this.isInited = false;
        this.isInitStart = false;
        this.widgetId = null;
        this.initResolves = [];
        this.prepareFormResolves = [];

        this.parent = options.parent;
        if (!this.parent?.el) {
            return;
        }
        this.siteKey = options.siteKey;

        if (this.parent) {
            this.parent.subscribe('shown', this.onFormShown.bind(this));
            if (this.parent.isShown()) {
                this.onFormShown();
            }
        }
    }

    setInited(value) {
        this.isInited = value;
        if (value) {
            this.initResolves.forEach((resolve) => {
                resolve();
            });
            this.initResolves = [];
        }
    }

    initScipt() {
        const baseSrc = 'https://smartcaptcha.yandexcloud.net/captcha.js';
        const script = document.createElement('script');
        script.src = baseSrc;
        script.dataset.isSmartCaptcha = true;
        script.addEventListener('load', this.onInitScript.bind(this));

        const otherScript = document.querySelector('script');
        if (otherScript) {
            otherScript.insertAdjacentElement('afterend', script);
        }
    }

    renderCaptcha() {
        const container = this.parent.el.querySelector('[data-smart-captcha]');
        if (!container) {
            console.error('SmartCaptcha container not found');
            return;
        }

        this.widgetId = window.smartCaptcha.render(container, {
            sitekey: this.siteKey,
            invisible: true,
            callback: this.onCaptchaCallback.bind(this),
        });
    }

    update(updateData) {

    }

    async prepareFormBeforeSend() {
        await new Promise(async (resolve, reject) => {
            // if (!this.isInitStart) {
            //     this.initScipt();
            // }
            if (!this.isInited) {
                await new Promise((resolve) => {
                    this.initResolves.push(resolve);
                });
            }

            if (!window.smartCaptcha) {
                reject('smartCaptcha not found');
                throw new Error('smartCaptcha not found');
            }

            this.prepareFormResolves.push(resolve);
            window.smartCaptcha.execute(this.widgetId);
        });
    }

    processAfterSend(response) {
        window.smartCaptcha.reset(this.widgetId);
    }

    onCaptchaCallback(token) {
        this.prepareFormResolves.forEach((resolve) => {
            resolve();
        });
        this.prepareFormResolves = [];
    }

    onInitScript() {
        if (!window.smartCaptcha) {
            console.error('SmartCaptcha not inited');
            return;
        }

        this.renderCaptcha();
        this.setInited(true);
    }

    onFormShown(e) {
        this.initScipt();
    }
}